import { Routes } from '@angular/router';
import { EquipmentListviewComponent } from './Pages/equipment-listview/equipment-listview.component';
import { EquipmentManagementComponent } from './Pages/equipment-management/equipment-management.component';
import { authGuard } from '../../../../src/app/auth.guard';
import { UserRoleType } from 'BaseDataTypes';
import { EquipmentMobileSiteComponent } from './Pages/equipment-mobile-site/equipment-mobile-site.component';
import { EquipmentInfoTabComponent } from './Pages/equipment-mobile-site/equipment-info-tab/equipment-info-tab.component';
import { EquipmentDocsTabComponent } from './Pages/equipment-mobile-site/equipment-docs-tab/equipment-docs-tab.component';
import { EquipmentHomeTabComponent } from './Pages/equipment-mobile-site/equipment-home-tab/equipment-home-tab.component';
import { EquipmentBorrowTabComponent } from './Pages/equipment-mobile-site/equipment-borrow-tab/equipment-borrow-tab.component';
import { EquipmentControlStatusTabComponent } from './Pages/equipment-mobile-site/equipment-control-status-tab/equipment-control-status-tab.component';
import { EquipmentPerformControlTabComponent } from './Pages/equipment-mobile-site/equipment-perform-control-tab/equipment-perform-control-tab.component';

const equipmentRouteConfig: Routes = [
  { path: '', redirectTo: 'søgudstyr', pathMatch: 'full' },

  {
    path: 'søgudstyr',
    title: 'Søg udstyr',
    component: EquipmentListviewComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin] },
  },

  {
    path: 'opretudstyr',
    title: 'Opret udstyr',
    component: EquipmentManagementComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin] },
  },

  {
    path: 'opretudstyr/:id',
    title: '',
    component: EquipmentManagementComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin] },
  },

  // Gammel QR-url, nu håndteret af Angular
  {
    path: 'borrowequipment.aspx',
    title: '',
    component: EquipmentMobileSiteComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin, UserRoleType.User] },
  },

  // Ny URL
  {
    path: 'kontrollerudstyr/:id',
    title: '',
    component: EquipmentMobileSiteComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin, UserRoleType.User] },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      { path: 'home', component: EquipmentHomeTabComponent },
      { path: 'info', component: EquipmentInfoTabComponent },
      { path: 'docs', component: EquipmentDocsTabComponent },
      { path: 'borrow', component: EquipmentBorrowTabComponent },
      { path: 'controlstatus', component: EquipmentControlStatusTabComponent },
      { path: 'performcontrol', component: EquipmentPerformControlTabComponent },
    ],
  }
];

export default equipmentRouteConfig;
